import slugify from 'slugify';

export const createTreeSlug = (name: string, id: string): string => {
  const baseSlug = slugify(name, {
    lower: true,
    strict: true,
    locale: 'es',
    remove: /[*+~.()'"!:@]/g
  });
  
  // Get only the first 3 words to keep URLs shorter
  const shortSlug = baseSlug.split('-').slice(0, 3).join('-');
  return `${shortSlug}-${id}`;
};

export const getIdFromSlug = (slug: string): string => {
  const parts = slug.split('-');
  return parts[parts.length - 1];
};